<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/expenses">{{ $t('purchase_payment') }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">[{{model.Num}}]</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <b-btn variant="outline-primary no-bor" size="sm" @click="clickSaveHandler"><i class="fa fa-floppy-o" aria-hidden="true"></i> {{$t('save')}}</b-btn>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <div v-if="$v.$error" class="alert alert-danger x-error">
                        <div class="error" v-if="!$v.model.AccountId.required">- សូមធ្វើការបញ្ជូលប្រភេទចំណាយ</div>
                        <div class="error" v-if="!$v.model.PaidAmount.required || !$v.model.Amount.minValue">{{$t('error.minZero')}}</div>
                        <div class="error" v-if="!$v.model.Description.required">- សូមធ្វើការបញ្ជូលបរិយាយចំណាយ</div>
                        <div class="error" v-if="!$v.date.required">- សូមធ្វើការបញ្ជូលកាលបរិច្ឆេទទទួលចំណាយ</div>
                    </div>
                    <form ref="form">
                        <div class="row">
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label class="label-control blue">{{$t('invoice_no')}}</label>
                                    <div>
                                        <input type="text" class="form-control form-control-sm" readonly v-model="model.PurchaseNum"/>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group" :class="{ 'form-group-error': $v.date.$error }">
                                    <label class="label-control blue">{{$t('date')}}</label>
                                    <div>
                                        <input type="date" class="form-control form-control-sm" v-model="date"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-3">
                                <div class="form-group" :class="{ 'form-group-error': $v.model.AccountId.$error }">
                                    <label class="label-control blue">{{$t('payment_menthod')}}</label>
                                    <div>
                                        <select class="form-control form-control-sm" v-model="model.AccountId" @change="bankChange">
                                            <option value=""></option>
                                            <option v-for="(ret,index) in banks" :value="ret.Id" :key="index">{{ret.Name}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label class="label-control blue">{{$t('total_amount')}}</label>
                                    <div>
                                        <input type="number" class="form-control form-control-sm" min="0" readonly v-model="model.Amount"/>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group" :class="{ 'form-group-error': $v.model.PaidAmount.$error }">
                                    <label class="label-control blue">{{$t('receive_amount')}}</label>
                                    <div>
                                        <input type="number" class="form-control form-control-sm" min="0" v-model="model.PaidAmount"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6">
                                <b-form-group class="label-control blue" :label="$t('description')" :class="{ 'form-group-error': $v.model.Description.$error }">
                                    <b-form-textarea v-model="model.Description"/>
                                </b-form-group>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { required, minValue } from 'vuelidate/lib/validators'
    export default {
        data: function(){
            return {
                model:{
                    Date: '',
                    Description: '',
                    AccountId: '',
                    PurchaseNum: '',
                    Amount: 0,
                    PaidAmount: 0,
                    PaidMethod: 'Cash'
                },
                date: this.$now().format('YYYY-MM-DD'),
                expenses: [],
                banks: [],
                actionLink: 'po/receipt/save'
            }
        },
        validations:{
            model: {
                AccountId: { required },
                Description: { required },
                PaidAmount: { required, minValue: minValue(0) }
            },
            date: { required }
        },
        created: function(){
            this.bankList();
            this.findById(this.$route.params.id);
        },
        methods: {
            findById(id){
                var loading = this.$loading.show();
                this.$api().post('po/receipt/find', { Id: id }).then(res => {
                    if(this.$isValid(res)){
                        this.model = res.data.Data;
                    }
                }).finally(function(){ loading.hide(); });
            },
            clickSaveHandler(){
                this.$v.$touch();
                if(!this.$v.$invalid){
                    var loading = this.$loading.show();
                    this.model.Date = this.date;
                    this.$api().post('po/receipt/update', this.model).then(res => {
                        if(this.$isValid(res)){
                            this.$router.push('/po/receipts');
                        }
                    }).finally(function(){ loading.hide(); });
                }
            },
            bankList(){
                this.$api().post('accounting/account/types', { AccountTypeNames: ['Bank'] }).then(res => {
                    if(this.$isValid(res)){
                        this.banks = res.data.Json.Accounts;
                    }
                });
            },
            bankChange(){
                var bank = this.banks.find(element => element.Id == this.model.AccountId );
                if(bank != undefined) this.model.PaidMethod = bank.Name;
            }
        }
    }
</script>
